// extracted by mini-css-extract-plugin
module.exports = {"container":"Breadcrumbs_container__ptBWH"};